import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { ValidDocuments } from '../valid-documents.model';

export enum CheckRequirementsActionTypes {
    LoadValidDocuments = '[Check Requirements] Load valid documents',
    LoadValidDocumentsSuccess = '[Check Requirements] Load valid documents success',
    LoadValidDocumentsFail = '[Check Requirements] Load valid documents fail',
    ClearCheckRequirements = '[Check Requirements] Clear valid documents and LoadCountriesCards',
    ShowCheckRequirementsPopup = '[Check Requirements] Show popup',
    HideCheckRequirementsPopup = '[Check Requirements] Hide popup',
}

@ShowLoader()
export class LoadValidDocuments implements Action {
    readonly type = CheckRequirementsActionTypes.LoadValidDocuments;
    constructor() { }
}

@HideLoader(CheckRequirementsActionTypes.LoadValidDocuments)
export class LoadValidDocumentsSuccess implements Action {
    readonly type = CheckRequirementsActionTypes.LoadValidDocumentsSuccess;
    constructor(public validDocuments: ValidDocuments) { }
}

@HideLoader(CheckRequirementsActionTypes.LoadValidDocuments)
export class LoadValidDocumentsFail implements Action {
    readonly type = CheckRequirementsActionTypes.LoadValidDocumentsFail;
    constructor(public payload: string) { }
}

export class ClearCheckRequirements implements Action {
    readonly type = CheckRequirementsActionTypes.ClearCheckRequirements;
    constructor() { }
}

export class ShowCheckRequirementsPopup implements Action {
    readonly type = CheckRequirementsActionTypes.ShowCheckRequirementsPopup;
    constructor(public countryId?: number, public userId?: string) {

    }
}

export class HideCheckRequirementsPopup implements Action {
    readonly type = CheckRequirementsActionTypes.HideCheckRequirementsPopup;
}



export type CheckRequirementsAction =
    LoadValidDocuments | LoadValidDocumentsSuccess | LoadValidDocumentsFail
    | ClearCheckRequirements
    | ShowCheckRequirementsPopup | HideCheckRequirementsPopup
    ;


